<div class="card mb-5" [style.min-height]="data.cardMinHeight">
  <div class="card-header" style="border-bottom: none;" [style.min-height]="data.headerMinHeight">
    <div class="card-title d-flex flex-column">
      <h4 [style.font-size]="data.titleFontSize">{{ data.title }}</h4>
      <p *ngIf="data.subtitle" class="waterfall-subtitle">{{ data.subtitle }}</p>
    </div>
  </div>
  <div class="card-body">
    <p *ngIf="data.dataSource?.mode === 'static' && data.labels?.sampleData" class="waterfall-source">{{ data.labels.sampleData }}</p>
    <div [id]="data.widgetId" [style.height]="data.chartHeight || '55vh'" [hidden]="hasError"></div>
    <app-data-error *ngIf="hasError" [message]="errorMessage" />
    <p *ngIf="!hasError && data.interaction?.hint" class="waterfall-hint">{{ data.interaction.hint }}</p>
    <div *ngIf="!hasError && selectedStep" class="waterfall-selection" aria-live="polite">
      <div><strong>{{ selectedStep.label }}</strong><span>{{ formatSelectedValue(selectedStep.value) }} {{ data.waterfall.unit }}</span></div>
      <button type="button" (click)="selectedStep = null">{{ data.interaction.clearSelection }}</button>
    </div>
    <div *ngIf="data.notes?.length" class="waterfall-notes">
      <p *ngFor="let note of data.notes"><strong>{{ note.title }}</strong> {{ note.description }}</p>
    </div>
  </div>
</div>
